import React from 'react';
import { WrenchIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { OfferBlock } from '../OfferBlock';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/o5B271KmwpyPEdU5oVcKuJ/REPARACIONES-IT.png';
export function Hero() {
  return <header className="relative overflow-hidden border-b border-white/10 bg-ink-950" data-id="element-160" data-mp="huxsjtb3wrxq">
      <div className="absolute inset-x-0 top-0 h-1 bg-accent" aria-hidden="true" data-id="element-161" data-mp="hsuvipbjdyji" />

      <div className="mx-auto w-full max-w-xl px-4 pb-12 pt-8 sm:pb-16 sm:pt-12 lg:max-w-6xl lg:pb-20" data-id="element-162" data-mp="mtsayu55wehb">
        <div className="flex items-center justify-center gap-2 lg:justify-start" data-id="element-163" data-mp="qtj7lehddotr">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent" data-id="element-164" data-mp="vmvtvhyktjjc">
            <WrenchIcon className="h-4 w-4 text-ink-950" aria-hidden="true" data-id="element-165" data-mp="10k45t0t4src5" />
          </span>
          <span className="font-display text-sm uppercase tracking-wide text-white sm:text-base" data-id="element-166" data-mp="15ltfod4mayyn">
            Sistema Tecnico PRO 360™
          </span>
        </div>

        <div className="mt-8 lg:mt-12 lg:grid lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14" data-id="element-167" data-mp="9nj5ny7pdq5v">
          <div data-id="element-168" data-mp="4o6l5k4b0v6g">
            <h1 className="text-center font-display text-[30px] uppercase leading-[1.05] text-white sm:text-4xl lg:text-left lg:text-[52px]" data-id="element-169" data-mp="4nogq07hnang">
              Costruisci un’attività professionale di riparazione elettrodomestici{' '}
              <span className="text-accent" data-id="element-170" data-mp="3rv8mlurlf3ub">in un solo giorno</span>
            </h1>

            <p className="mx-auto mt-5 max-w-md text-center text-[15px] leading-relaxed text-white/65 sm:text-base lg:mx-0 lg:max-w-lg lg:text-left lg:text-lg" data-id="element-171" data-mp="sdskq8ol9cez">
              Anche se hai ancora pochi clienti. Più di{' '}
              <strong className="font-semibold text-white" data-id="element-172" data-mp="imed1dmhh6ar">300 modelli, processi, protocolli e
              strumenti</strong>{' '}
              pronti all’uso per farti pagare con sicurezza, organizzare il tuo laboratorio e
              lavorare come un tecnico professionista fin dal primo intervento.
            </p>

            <div className="mt-8 lg:hidden" data-id="element-173" data-mp="30lxcu7ra86vn">
              <ProductImage data-id="element-174" data-mp="30n8gm7kq9emr" />
            </div>

            <div className="mt-8 space-y-5 lg:mt-9 lg:max-w-lg" data-id="element-175" data-mp="35l0k7yuqip6s">
              <div id="hero-cta" data-id="element-176" data-mp="35k8omo150rgi">
                <CtaButton label="Voglio il Sistema Tecnico PRO 360™" size="lg" note="Accesso immediato · Pagamento unico di 19 €" data-id="element-177" data-mp="2qw42tb6sfzti" />
              </div>
              <OfferBlock data-id="element-178" data-mp="2huwffo5t8je7" />
            </div>
          </div>

          <div className="hidden lg:block" data-id="element-179" data-mp="2hxsg3k91lm6c">
            <ProductImage data-id="element-180" data-mp="2muskzru5oivv" />
          </div>
        </div>
      </div>
    </header>;
}
function ProductImage() {
  return <figure className="mx-auto w-full max-w-md lg:max-w-none" data-id="element-181" data-mp="27yt5hw4pvggp">
      <img src={PRODUCT_IMAGE} alt="Sistema Tecnico PRO 360™: manuale principale, 6 sistemi, modelli stampabili e accesso da tablet e smartphone" className="w-full" width={1080} height={1080} data-id="element-182" data-mp="2cvtcc99e4n8v" />
      <figcaption className="mt-1 text-center text-[11px] uppercase tracking-wider text-white/40 sm:text-xs" data-id="element-183" data-mp="b4ga5ryt4tgi">
        Pacchetto completo con manuali, modelli e 5 sistemi premium
      </figcaption>
    </figure>;
}